export default __webpack_public_path__ + "static/media/a2-4-10.832b2c66.jpg";